import { GameService } from './../core/services/game.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { interval } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.scss"]
})
export class SidemenuComponent implements OnInit {
  clicked = false;
  vipContent = false;
  superVipContent = false;
  quickTutorial = false;
  help = false;
  private subProducts = [];
  quickTuturialUrl: any;
  helpUrl: any;
  lang: any;

  points = [];

  displayBackdrop = 'none';
  displayMenu = 'none';


  constructor(public gameservice: GameService, public router: Router, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.lang = localStorage.getItem('lang');

    if (this.lang == 'en') {
      this.quickTuturialUrl = this.sanitizer.bypassSecurityTrustResourceUrl('http://helm.tekmob.com/pim/gigagigaplayooredoo?p=8');
      this.helpUrl = this.sanitizer.bypassSecurityTrustResourceUrl('http://helm.tekmob.com/pim/gigagigaplayooredoo?p=6');
    } else if(this.lang == 'ar') {
      this.quickTuturialUrl = this.sanitizer.bypassSecurityTrustResourceUrl('http://helm.tekmob.com/pim/gigagigaplayooar?p=13');
      this.helpUrl = this.sanitizer.bypassSecurityTrustResourceUrl('http://helm.tekmob.com/pim/gigagigaplayooar?p=11');
    }

    this.getPlayerData();
  }

  getPlayerData() {
    this.gameservice.getPlayerData().subscribe(data => {
      if (data["responseCode"] >= 400) {
        localStorage.clear();
        this.router.navigate(['/login']);
      } else {
        this.points = [
          data["responseData"].wallet.counters[0],
          data["responseData"].wallet.counters[3]
        ];
       
      }
      // console.log(data);
    });
  }

  openSideNav(){
    this.getPlayerData();
    this.displayBackdrop = 'block';
    this.displayMenu = 'block';
  }
  closeMenu(){
    this.displayBackdrop = 'none';
    this.displayMenu = 'none';
  }
}
